import React, { Component } from "react";

import {
  CModal,
  CModalHeader,
  CModalBody,
  CLabel,
  CInput,
  CModalFooter,
  CButton,
  CSpinner,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import { loDaResposta } from "../../utils/loSingleView";

import "./css/content.css";

class LinkCreator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      url: "",
      loading: false
    };
  }

  componentDidMount() {
    axios
      .get(`${URL.api}content/los/singleView/${this.props.currentLOLink}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        const lo = loDaResposta(resp);
        this.setState({ url: lo.path || "", name: lo.name });
      });
  }

  insertLink() {
    if (this.state.url === "") {
      toastr.warning("Atenção", "Preencha o campo de link!");
      return;
    }

    if (this.state.name === "") {
      toastr.warning("Atenção", "Preencha o campo de nome do link!");
      return;
    }

    let obj = {
      name: this.state.name,
      type_id: 16,
      path: this.state.url,
      ability_id: 1,
      released: true,
      private: true,
      flash: false,
      user_id: this.props.user.user.id,
      skin_id: 1,
      resume: "Link adicionado em uma atividade",
      objective: 1,
      image: "content/types/listaQuestoes.png",
      year: new Date().getFullYear(),
      author: this.props.user.user.name,
      source_id: 1,
      difficulty_level_id: 1,
      language_id: 1,
      status: "Liberado",
      printable: false
    };

    this.setState({ loading: true });

    axios
      .post(`${URL.api}content/los/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ loading: false });
          this.props.getContent({
            type: 16,
            list: [{ id: resp.data.data, name: this.state.name }]
          });
          this.props.onClose();
        },
        error => {
          this.setState({ loading: false });
        }
      );
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Inserir link</CModalHeader>
        <CModalBody>
          <CFormGroup>
            <CLabel>Nome</CLabel>
            <CInputGroup>
              <CInputGroupPrepend>
                <CInputGroupText>
                  <i className="fa fa-text-width" />
                </CInputGroupText>
              </CInputGroupPrepend>
              <CInput
                value={this.state.name}
                onChange={e => this.setState({ name: e.target.value })}
                placeholder="Nome do link"
              />
            </CInputGroup>
          </CFormGroup>
          <CFormGroup className="mt-3">
            <CLabel>Link</CLabel>
            <CInputGroup>
              <CInputGroupPrepend>
                <CInputGroupText>
                  <i className="fa fa-link" />
                </CInputGroupText>
              </CInputGroupPrepend>
              <CInput
                value={this.state.url}
                onChange={e => this.setState({ url: e.target.value })}
                placeholder="Link"
              />
            </CInputGroup>
          </CFormGroup>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="d-flex justify-content-center align-items-center"
            disabled={this.state.loading}
            onClick={() => this.insertLink()}
          >
            <>
              <span style={this.state.loading ? { opacity: 0 } : null}>
                Inserir
              </span>
              {this.state.loading && (
                <CSpinner
                  size="sm"
                  color="white"
                  style={{ position: "absolute" }}
                />
              )}
            </>
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkCreator);
